<template>
<div class="container">

<div class="form">

<div class="row">
	<div class="col-3 left">姓&nbsp;&nbsp;名</div>
	<div class="col-7 text-middle">
		{{f.xm}}
	</div>
</div>

<div class="row">
	<div class="col-3 left">性&nbsp;&nbsp;别</div>
	<div class="col-7 text-middle">
		{{f.xb?"男":"女"}}
	</div>
</div>

<div class="row">
	<div class="col-3 left">身份证</div>
	<div class="col-7">
		<mt-field placeholder="请输入身份证号码" v-model="f.sfzh"></mt-field>
	</div>
</div>


<div class="row">
	<div class="col-3 left">手机号</div>
	<div class="col-7">
		<mt-field placeholder="请输入手机号码" v-model="f.dh"></mt-field>
	</div>
</div>

<div class="row">	
	<div class="col-3 left nopadding">验证码</div>
	<div class="col-4 nopadding">
		 <mt-field placeholder="请输入验证码" v-model="f.code" @keydown.native.enter="get_telcode" @input="check"></mt-field>
	</div>
	<div class="col-3 nopadding codediv">
		 <img :src="codeurl+f.tk" class="code" alt="验证码" @click="change">
		 <span class="success" v-show="success"><i class="fa fa-check"></i></span>
	</div>
</div>

<div class="row">	
	<div class="col-3 left" style="letter-spacing:0;">手机验证</div>
	<div class="col-4">
		 <mt-field placeholder="请输入手机验证码" v-model="f.telcode"></mt-field>
	</div>
	<div class="col-3 nopadding">
		<mt-button class="btn" type="primary" @click="get_telcode">获 取</mt-button>
	</div>
</div>


</div> <!-- end-form -->

<div class="row pd">
	<mt-button type="primary" size="large" @click="sub">保存更新</mt-button>
</div>

<div class="row pd">
	<mt-button type="primary" size="large" @click="topsd">修改密码</mt-button>
</div>

<div class="row pd">
	<mt-button type="danger" size="large" @click="logout">退出登录</mt-button>
</div>
	
</div>	
</template>

<style scoped>
.container{background: rgb(251,251,251);}
.pd{padding:.5rem 1rem;}
.text-middle{height:3rem;line-height:3rem;padding-left:.5rem;}
.btn{border-radius:0;float:right;width:100%;height:52px;}
</style>

<script>
import hos from "../../lib/hos.vue"

export default {
   components:{hos},
   data(){
   	return {
		title:"个人资料",
		mydata:mydata,
		f:{
			xm:"",
			sfzh:"",
			dh:"",
			xb:true,
			code:"",
			tk:"",
			telcode:""
		},
		codeurl:mydata.api+"Code/code?tk=",
		success:false,
   	}
   },
   created:function(){
   	 this.init();
   },
   methods:{
   	init:function(){
	  this.$emit("setTitle","个人资料");
	  var _this=this;
      fun.post(mydata.apiuser+"getinfo",{},function(d){
           console.log(d);
           if(d.status==1){
			   _this.f.xm=d.info.xm;
			   _this.f.sfzh=d.info.sfzh;
			   _this.f.xb=d.info.xb;
			   _this.f.dh=d.info.dh;
			   _this.change();
           }else{
           	_this.$messagebox.alert(d.info);
           }
      })
   	},
   	topsd:function(){
     this.$router.push("/user/safe");
   	},
   	logout:function(){
   	  var _this=this;
      this.$messagebox.confirm("确定退出登录吗？").then(function(d){
      	fun.post(mydata.apiuser+"logout",{},function(d){
      		console.log(d);
      		if(d.status==1){
				fun.logout();
				_this.$router.push("/");
      		}else{
      			_this.$messagebox.alert(d.info);
      		}
      	})
      },function(e){
        console.log(e);
      })
	   },
	check:function(){
	   var _this=this;
	   if(this.f.code.length!=4){this.success=false;return;}
	   fun.post(mydata.api+"Code/mycheck",this.f,function(d){
		   fun.log(d)
		   if(d.status==1){
			   _this.success=true;
		   }else{
			   _this.success=false;
		   }
	   })
	},
	change:function(){
	   this.f.tk=fun.get_tk();
	},
	get_telcode:function(){
	  var _this=this;
	  if(this.f.code==false){this.$toast("请输入验证码");return;}
	  if(this.f.dh.length!=11){this.$toast("手机号码有误");return;}
	  if(this.f.sfzh.length!=15&&this.f.sfzh.length!=18){this.$toast("身份证号码有误");return;}
	  fun.post(mydata.apiuser+"userinfo_get_telcode",this.f,function(d){
		  fun.log(d);
		  _this.$toast(d.info);
	  })
	},
   	sub:function(){
   		var _this=this;
   		fun.post(mydata.apiuser+"saveinfo",this.f,function(d){
			   console.log(d);
			   if(d.status==0){
				    _this.change();
				   _this.$toast(d.info);
			   }else{
                  _this.$messagebox.alert(d.info);
			   } 
   		})
   	}
   }
}	
</script>


// WEBPACK FOOTER //
// src/components/user/info.vue